import PropTypes from 'prop-types';
import * as React from 'react';
import { useMemo } from 'react';
import { MANIFEST_THEMES } from '../../../core/manifest/themes.js';
import { useSwanHeadConfig } from './head.hook.js';
import { getSameKeyValueMapForManifest, manifestResolve } from '../../../core/utilities/manifest.utils.js';
import { isNonNullish } from '../../../core/utilities/is.utils.js';
import { SwanAssetFolders } from '../../../core/types/enums.js';
import { swanLoaderConfigProps } from '../../contexts/swan-provider/swan-provider.context.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
getSameKeyValueMapForManifest(MANIFEST_THEMES);
_object_spread({
    themeKeys: PropTypes.arrayOf(PropTypes.oneOf([
        'holiday'
    ]).isRequired)
}, swanLoaderConfigProps);
/**
 * @subcomponent SwanHead
 */ const SwanThemes = ({ themeKeys, swanBaseUrl, swanPathType, swanTenant, swanLocale, renderWith: Comp = React.Fragment })=>{
    const { swanBaseUrl: baseUrl, swanPathType: pathType } = useSwanHeadConfig(swanBaseUrl, swanPathType, swanTenant, swanLocale);
    const urls = useMemo(()=>{
        if (Array.isArray(themeKeys) && themeKeys.length > 0) return themeKeys.map((key)=>getSwanThemeUrl(key, pathType, baseUrl)).filter(isNonNullish);
        return null;
    }, [
        baseUrl,
        pathType,
        themeKeys
    ]);
    if (!urls) return null;
    return /*#__PURE__*/ React.createElement(Comp, null, urls.map((url)=>/*#__PURE__*/ React.createElement("link", {
            rel: "stylesheet",
            href: url,
            key: url
        })));
};
function getSwanThemeUrl(key, pathType, swanAssetBaseUrl) {
    return manifestResolve(MANIFEST_THEMES, key, SwanAssetFolders.THEMES, pathType, swanAssetBaseUrl);
}

export { SwanThemes, getSwanThemeUrl };
